import { Button, CircularProgress } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { AD_IMAGE_MAX_BYTES, AD_IMAGE_TYPES } from "./marketingFormat";

/** Uploads straight to the chosen ad account so the form only ever holds Meta's image hash. */
export default function AdImagePicker({ uploading, hash, onPick }) {
  const input = useRef(null);
  const [preview, setPreview] = useState(null);

  useEffect(
    () => () => {
      if (preview) URL.revokeObjectURL(preview);
    },
    [preview]
  );

  const choose = (event) => {
    const file = event.target.files?.[0];
    event.target.value = "";
    if (!file) return;
    if (!AD_IMAGE_TYPES.includes(file.type)) {
      toast.error("Choose a JPEG or PNG image");
      return;
    }
    if (file.size > AD_IMAGE_MAX_BYTES) {
      toast.error("The image must be 8 MB or smaller");
      return;
    }
    setPreview(URL.createObjectURL(file));
    onPick(file);
  };

  return (
    <div className="flex items-center gap-3">
      <input
        ref={input}
        type="file"
        accept={AD_IMAGE_TYPES.join(",")}
        hidden
        aria-label="Ad image file"
        onChange={choose}
      />
      {preview ? (
        <img src={preview} alt="Ad preview" className="h-20 w-20 rounded object-cover" />
      ) : null}
      <div>
        <Button
          variant="outlined"
          size="small"
          disabled={uploading}
          onClick={() => input.current?.click()}
        >
          {hash ? "Replace image" : "Choose image"}
        </Button>
        <p className="mt-1 text-xs text-app-text-muted">
          {uploading ? (
            <>
              <CircularProgress size={12} /> Uploading to Meta…
            </>
          ) : hash ? (
            "Image uploaded to Meta."
          ) : (
            "JPEG or PNG, up to 8 MB. Square or 1.91:1 works best."
          )}
        </p>
      </div>
    </div>
  );
}
